// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__lR7kj","content":"style_content__gSim7","footer":"style_footer__3BhaV"};